module.exports = __webpack_public_path__ + "media/welcome-message/all_hands@1x-ed93bdab.png";